module.exports = "/_next/static/images/UnifyCustomerProfileMobile-104bec4345dd8c1e8c950d2086fc354f.webp";